<template>
  <div :class="base + ' ' + (model.isFollow ? 'btn-blue' : 'btn-default')" @click="$com.addFollow(model, type)">
    <span class="icon iconfont icon-shoucang"></span>{{ model.isFollow ? '移除' : '收藏' }}
  </div>
</template>

<script>
export default {
  props: {
    base: { type: String, default: "item-btn" },
    model: { type: Object, default: {} },
    type: { type: String, default: "book" },
  }
}
</script>



// WEBPACK FOOTER //
// src/common/ButtonFollowView.vue